import React, { useContext, useEffect, useState } from "react";
import AppState from "../../context/AppContext";
import { v4 as uuidv4 } from "uuid";
import "../../styles/pages/letterToSanta.scss";
import ChristmasButton from "../ChristmasButton";
import dabbingSanta from "../../images/dabbingSanta.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import EditChildGift from "./EditChildGift";
import DeleteChildGift from "./DeleteChildGift";
import jingle from "../../images/jingle.mp3";
import { useNavigate } from "react-router-dom";

const LetterToSantaChild = () => {
  const context = useContext(AppState);
  const navigate = useNavigate()
  const [showLogin, setShowLogin] = useState(false);
  const [errors, setErrors] = useState([]);
  const [buttonText, setButtonText] = useState("All Done");
  const [showEditGift, setShowEditGift] = useState(false);
  const [showDeleteGift, setShowDeleteGift] = useState(false);

  useEffect( () => {
    if(context.store.parentMode){
      navigate("/letter-to-santa-parent")
    }
  }, [ navigate, context.store.parentMode ] );
  const addPresent = (event) => {
    event.preventDefault();
    context.store.children.map((v, i) => {
      if (v.uid === context.store.currentChild) {
        return v.list.push(event.target.present.value);
      }
      return undefined;
    });
    event.target.present.value = "";
    context.setStore({
      ...context.store,
    });
  };
  const playSound = () => {
    const audioElement = new Audio(jingle);
    audioElement.play();
  };
  const finalizeList = (event) => {
    event.preventDefault();
    context.store.children.map((v, i) => {
      if (v.uid === context.store.currentChild) {
        let formattedGifts = {
          uid: uuidv4(),
          gifts: [],
        };
        v.list.map((v, i) => {
          return formattedGifts.gifts.push({ gift: v });
        });
        context
          .addChildGiftList(context.store.currentChild, formattedGifts)
          .then((response) => response)
          .catch(console.log);
      }
      return undefined;
    });
    setButtonText("");
    playSound();
    setShowLogin(true);
  };
  const loginSubmit = (event) => {
    event.preventDefault();
    let userDetails = {
      email: event.target.email.value,
      password: event.target.password.value,
    };
    context
      .login(userDetails)
      .then((data) => {
        if (data) {
          navigate("/letter-to-santa-parent")
          context.store.parentMode = true;
          context.setState({
            ...context.store,
          });
        }
      })
      .catch(() => {
        setErrors([1]);
      });
  };
  const handleEditGift = (event) => {
    setShowEditGift(true);
    context.store.editGift = true;
    context.store.currentGift = event.currentTarget.getAttribute("uid");
    context.setStore({
      ...context.store,
    });
  };
  const handleCloseEditGift = (event) => {
    setShowEditGift(false);
    context.store.editGift = false;
  };
  const handleDeleteGift = (event) => {
    setShowDeleteGift(true);
    context.store.deleteGift = true;
    context.store.currentGift = event.currentTarget.getAttribute("uid");
    context.setStore({
      ...context.store,
    });
  };
  const handleCloseDeleteGift = (event) => {
    setShowDeleteGift(false);
    context.store.editGift = false;
  };
  return (
    <div>
      <h1 className="my-5">
        <u>Child Mode</u>
      </h1>
      <div className="row">
        <div className="col d-flex flex-column aling-items-center justify-content-center">
          <img className="santa" src={dabbingSanta} alt="santa" />
        </div>
        <div className="col my-3">
          <h3>My List</h3>
          <div className="float-lg-end">
            {context.store.children.map((children, i) => {
              if (children.uid === context.store.currentChild) {
                return children.list.map((present, i) => {
                  return (
                    <div key={i}>
                      <li>
                        <h4>{present}</h4>
                      </li>
                      &nbsp;&nbsp;&nbsp;
                      <button uid={present} onClick={handleEditGift}>
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      &nbsp;&nbsp;
                      <button uid={present} onClick={handleDeleteGift}>
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    </div>
                  );
                });
              }
              return undefined;
            })}
          </div>
        </div>
      </div>
      <form
        onSubmit={addPresent}
        className="d-flex justify-content-center align-items-center flex-column"
      >
        <h3>What can santa get for you?</h3>
        <input
          required
          type="text"
          name="present"
          placeholder="What would you like?"
        ></input>

        <input
          className="christmasInputButton buttonFont m-2"
          type="submit"
          value="Add Present"
        ></input>
      </form>
      <div className="d-flex justify-content-center align-items-center my-3">
        <ChristmasButton text={buttonText} onClick={finalizeList} />
      </div>

      {showLogin ? (
        <div className="secondaryLogin">
          {errors.length > 0 ? (
            <h5 className="errors d-flex flex-column align-items-center">
              That's not Right
            </h5>
          ) : (
            ""
          )}
          <form
            className="login d-flex flex-column align-items-center"
            onSubmit={loginSubmit}
          >
            <p>
              Call your parent(s) and present your masterpiece letter for
              santa!
            </p>
            <label>Username/E-Mail</label>
            <input
              required
              className="username mb-2"
              type="email"
              name="email"
              placeholder="Enter a email"
            ></input>

            <label>Password</label>
            <input
              required
              className="password mb-2"
              type="password"
              name="password"
              placeholder="Enter a password"
            ></input>

            <input
              className="christmasInputButton m-2"
              type="submit"
              value="Login"
            ></input>
          </form>
        </div>
      ) : (
        ""
      )}
      {context.store.editGift ? (
        <EditChildGift
          open={showEditGift}
          handleClose={handleCloseEditGift}
          uid={context.store.currentGift}
        />
      ) : (
        ""
      )}
      {context.store.deleteGift ? (
        <DeleteChildGift
          open={showDeleteGift}
          handleClose={handleCloseDeleteGift}
          uid={context.store.currentGift}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default LetterToSantaChild;
